import api from './api';

export const orderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOrderForToday: builder.query({
      query: ({ restaurantId, id }) => `orders/GetOrderForToday/${restaurantId}${id ? '/' + id : ''}`,
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetOrderForTodayQuery,
} = orderApi;